/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export enum VALUE_KEYS {
  merchantGuid = 'merchantGuid',
  accessToken = 'accessToken',
  paymentCreditCard = 'paymentCreditCard',
  expMonth = 'expMonth',
  expYear = 'expYear',
  type = 'type',
  CVV = 'CVV',
}
